<p-toast position="top-center" key="error" (onClose)="onClose()" [baseZIndex]="5000">
    <ng-template pTemplate="message">
        <div class="flex flex-column" style="flex: 1">
            <div class="text-center">
                <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
                <h4>Atención</h4>
                <ul>
                    <li *ngFor="let message of messages"> {{ message }}</li>
                </ul> 
            </div>
            <div class="grid p-fluid">
                <div class="col-12">
                    <button type="button" pButton (click)="onClose()" label="Entendido" class="p-button-secondary"></button>
                </div>
            </div>
        </div>
    </ng-template>
</p-toast>